import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { getCommentadjective } from '../hotel-result/hotel-result-funtions';

@Component({
  selector: "usb-transport-result",
  templateUrl: "./transport-result.component.html",
  styleUrls: ["../../../base-result.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransportResultComponent implements OnInit {


  roundTripTime: any;
  @Input() result: any;
  @Input() clientsSettingAppBooking;

  constructor(
            ) {}

  ngOnInit() {
    this.validateEntryAndReturnTime();
  }

   /**
   * Genera la suma total de los minutos
   * En el caso que solo sea ida y vuelta, indicará la suma total de entryTravelTime y returnTravelTime.
   * Si es solo ida, mostrara solo el entryTravelTime.
   */
  validateEntryAndReturnTime(): void {
    const entryTime = this.result.vehicles[0].timing.entry.entryTravelTime;
    const returnTime = this.result.vehicles[0].timing.return.returnTravelTime;

    if (entryTime && !returnTime) {
      this.roundTripTime = Number(entryTime);
    } else {
      this.roundTripTime = Number(entryTime) + Number(returnTime);
    }
  }

    getCommentadjective(average: any): any {
      return getCommentadjective(average);
    }


}
